<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">

      <el-form-item :label="$t('lang.食谱分类')" required>
        <el-select v-model="formData.refCategoryCodes" clearable :placeholder="$t('lang.请选择')" multiple>
          <el-option v-for="i in categoryList" :key="i.recipeCategoryCode" :label="i.name" :value="i.recipeCategoryCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
import {recipeCategoryList} from "../../js/common";
export default {
  name: "FittingAdd",
  data() {
    return {
      api: {
        add: this.$api.appOnlineCategory.add,
      },
      formData: {
        refCategoryCodes: [],
      },
      categoryList: []
    }

  },
  computed: {
    rules() {
      return {
        lang: [
          {required: true, message: this.$t('lang.主语言不能为空'), trigger: 'blur'}
        ],
      }
    },

  },
  methods: {
    handleSubmit(form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let params = {
            refCategoryCodes: this.formData.refCategoryCodes.join(",")
          }
          vm.$http.post(vm.api.add, vm.$qs.stringify(params)).then((resp) => {
            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.back();
            } else if (resp.data.status === 400) {
              if (resp.data.desc) {
                vm.$message({
                  type: "error",
                  message: resp.data.desc
                });
              }
            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    }
    ,
    handleReset(form) {
      this.$refs[form].resetFields();
      this.formData.refCategoryCodes = [];
    }
  }
  ,
  async created() {
    this.categoryList = await recipeCategoryList(this);
  }
}
</script>

<style scoped>

.fb-form {
  max-width: 500px;
}


.lang-box {
  display: flex;
  margin-top: 14px;
}


/deep/ .el-radio {
  line-height: 40px;
}

</style>
